import * as React from 'react';

import {Button} from 'shells/button/button';
import {TextField} from 'shells/textfield/textfield';

type Props = {
    name?: string;
    value: string;
    onChange: (value: string) => void;
    autoFocus?: boolean;
    isSaving: boolean;
    disableButton?: boolean;
    isAddButton?: boolean;
    focusOnMount?: boolean;
    onSave?: () => void;
    disableTextField?: boolean;
};

export function TextfieldWithSave(props: Props) {
    const {
        name,
        value,
        onChange,
        autoFocus,
        focusOnMount,
        isSaving,
        onSave,
        disableButton,
        isAddButton,
        disableTextField,
    } = props;

    const getButtonText = () => {
        if (isAddButton) {
            return isSaving ? 'Adding…' : 'Add';
        } else {
            return isSaving ? 'Saving…' : 'Save';
        }
    };

    return (
        <div className='flex mb-8'>
            <div className='mr-16 flex-grow'>
                <TextField
                    // @ts-expect-error
                    name={name}
                    placeholder='example.com'
                    value={value}
                    onChange={onChange}
                    autoFocus={autoFocus}
                    onEnter={onSave}
                    selectOnFocus={true}
                    focusOnMount={focusOnMount}
                    disabled={disableTextField}
                />
            </div>
            {onSave ? (
                <Button size='big' variant='save' onClick={onSave} disabled={disableButton}>
                    {getButtonText()}
                </Button>
            ) : undefined}
        </div>
    );
}
